import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ErrorShowService } from '../services/error-show.service';
import { LoginService } from '../services/login.service';
import { TokenService } from '../services/token.service';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RouterEvent } from '@angular/router';
import { RememberMeService } from '../services/remember-me.service';
import Swal from 'sweetalert2';
import { RoleAccessService } from '../services/roleAccess.service';
import { SharedALLService } from '../services/shared-all.service';
import { HttpParams } from '@angular/common/http';
import { commonClass } from '../models/commonClass';
import { NavbarDateShareService } from '../services/navbar-date-share.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  fieldTextType = false;
  loading: boolean = false;
  rememberMeEmail: string = ''
  rememberMePassword: string = ''
  remembermeStatus: boolean = true;
  loginWithOtp: boolean = false;
  enterOtp: boolean = false;
  otp: string = "";
  phonenumber: string;
  displayTimer: any;
  resendOTP: boolean = false;
  changeMobile: boolean = false;
  popup: boolean = false;
  constructor(public rememberService: RememberMeService, private shareService: SharedALLService,
    private formBuilder: FormBuilder, private navShareService: NavbarDateShareService,
    private router: Router, private roleService: RoleAccessService,
    private loginService: LoginService,
    private tokenService: TokenService,
    private errorShowService: ErrorShowService,
    @Optional() public dialogRef: MatDialogRef<LoginComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data?: any
  ) {
    this.popup = data ? data["params"]:false;
  }

  ngOnInit() {
    this.errorShowService.SyncAndFlushData();
    if (this.tokenService.getRememberMe() != null && this.tokenService.getRememberMe() != "false"){
      //consolethis.tokenService.getRememberMeDetails())
      this.rememberMeEmail = this.tokenService.getRememberMeDetails().email;
      this.rememberMePassword = this.tokenService.getRememberMeDetails().password;
      this.remembermeStatus = this.tokenService.getRememberMeDetails().rememberMe
    }
    //consolethis.rememberMeEmail)
    this.tokenService.signout()
    this.loginForm = this.formBuilder.group({
      email: [this.rememberMeEmail, [Validators.required, Validators.email]],
      password: [this.rememberMePassword, [Validators.required, Validators.minLength(6)]],
      rememberMe: [this.remembermeStatus]
    });
    //this.tokenService.resetDashboardTheme();
  }

  get f() {
    return this.loginForm.controls;
  }

  public showVar;

  toggleChild() {
    this.showVar = !this.showVar;
    this.fieldTextType = !this.fieldTextType;
  }
  onSubmit() {
    localStorage.removeItem("adminCorner");
    this.submitted = true;    
    if (this.loginForm.invalid) {
    } else {
      this.loading = true;
      this.loginService.loginService(this.loginForm.value).subscribe({
        next: (res) => {
          if (res['MESSAGE'] === 'Successful') {
            this.tokenService.setLoginData(this.loginForm.value, res['DATA'][0])
            this.navShareService.setauthCode(res['DATA'][0]['AUTH_CODE'])
            if (this.popup) {
              this.dialogRef.close();
            }
            else {
              this.router.navigateByUrl(this.roleService.getDefaultRedirection());
            }
            this.navShareService.isNotify$.subscribe(data => {
              if (data && this.tokenService.getUserId()) {
                this.deviceAPI();
              }
            })
            this.loaderclose();
          } else {
            this.loading = false;
            this.errorShowService.showError(res['MESSAGE']);
          }
        },
        error: (err) => {
          console.log(err)
          this.errorShowService.showError(err);
          this.loading = false;
        },
      });
    }
  }
  deviceAPI() {
    var navigator_info = window.navigator;
    var screen_info = window.screen;
    var uid = navigator_info.mimeTypes.length.toString();
    uid += navigator_info.userAgent.replace(/\D+/g, '');
    uid += navigator_info.plugins.length;
    uid += screen_info.height || '';
    uid += screen_info.width || '';
    uid += screen_info.pixelDepth || '';

    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('token', localStorage.getItem('fireToken'))
      .set('device', 'web')
      .set('version', commonClass.VERSIONNUMBER)
      .set('deviceid', uid)
      .set('os', 'web');
    this.shareService.callAPI("POST", 'device_v2.php', apiRequest).subscribe(res => {
      console.log(res)
    });
  }
  loaderclose() {
    this.router.events.subscribe((routerEvent: RouterEvent) => {
      if (routerEvent instanceof NavigationEnd && routerEvent.url.includes("/dashboard")) {
        this.loading = false;
      }
    });
  }

  checkRouterEvent(routerEvent: RouterEvent): void {
    console.log("here")
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }

  loginwithotpshow() {
    this.loginWithOtp = true;
  }
  loginwithotpclose() {
    this.loginWithOtp = false;
  }
  getotp() {
    
    this.resendOTP = false;
    this.loading = true;
    var phoneToPass = "";
    if (this.phonenumber.charAt(0) == "+") {  //If number starts with + no change
      phoneToPass = encodeURIComponent(this.phonenumber)
    }
    else if (this.phonenumber.charAt(0) == "1") { //If number not + but starts with 1 only add +
      phoneToPass = encodeURIComponent("+" + this.phonenumber)
    }
    else if (this.phonenumber.length > 10) {
      phoneToPass = encodeURIComponent("+" + this.phonenumber)
    }
    else if (this.phonenumber.length == 10) {
      phoneToPass = encodeURIComponent("+" + "1" + this.phonenumber)
    }
    else {
      this.errorShowService.showError("Please enter valid phone number");
      this.loading = false;
      return false;
    }
    this.loginService.getOtp(phoneToPass).subscribe(data => {
      this.loading = false;
      if (data["STATUS"] == 0) {
        this.errorShowService.showError(data['MESSAGE']);
      }
      else {
        this.changeMobile = true;
        this.errorShowService.showSucess(data["MESSAGE"])
        this.enterOtp = true;
        this.timer(0.5);
      }
    }, error => {
      this.errorShowService.showError(error['MESSAGE']);
      this.loading = false;
    })
    return true;
  }
  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 30;
    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 30;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;
      this.displayTimer = `${prefix}${Math.floor(seconds / 30)}:${textSec}`;

      if (seconds == 0) {
        //console.log("finished");
        //TODO
        this.resendOTP = true;
        //this.enterOtp = false;
        clearInterval(timer);
      }
    }, 1000);
  }
  resendOTPClick() {
    this.getotp();    
  }
  radioChange(e) {   
    switch (e.target.value) {
      case "Email": {
        this.loginWithOtp = false;
        break;
      }
      case "Phone": {
        this.loginWithOtp = true;
        break;
      }
    }
  }
  validateotp() {
    this.loading = true;
    var phoneToPass = "";
    if (this.phonenumber.length > 10) {     
      phoneToPass = "+" + this.phonenumber
    }
    else if (this.phonenumber.length == 10) {
      phoneToPass = encodeURIComponent("+" + "1" + this.phonenumber)
    }
    else {
      this.errorShowService.showError("Please enter valid phone number");     
    }
    this.loginService.validateOtp({ mobile: phoneToPass, otp: this.otp }).subscribe(async data => {
      this.loading = false;
      if (data["STATUS"] == 0) {
        this.errorShowService.showError(data['MESSAGE']);
      }
      else {
        if (data["IS_PROJECTLIST"] == "false") {
          this.tokenService.setLoginData({ email: '', password: '', rememberMe: this.remembermeStatus}, data['DATA'][0])
          if (this.popup) {
            this.dialogRef.close();
          }
          else {
            this.router.navigateByUrl(this.roleService.getDefaultRedirection());
          }
          this.navShareService.isNotify$.subscribe(data => {
            if (data && this.tokenService.getUserId()) {
              this.deviceAPI();
            }
          })
          this.loaderclose();
        }
        else {
          var projectlist = data["DATA"].map(x => x["PROJECTNAME"])
          const { value: project } = await Swal.fire({
            title: "Please select project",
            input: 'select',
            inputOptions: projectlist,
            inputPlaceholder: 'Select a project',
            showCancelButton: false,
            inputValidator: (value) => {
              return new Promise((resolve) => {
                if (value) {
                  resolve('');
                } else {
                  resolve('You need to select at least one project')
                }
              })
            }
          })
          if (project) {
            var userid = data["DATA"][project]["USERID"]
            this.loading = true;
            this.loginService.loginOtp({ userid: userid }).subscribe(data => {
              this.loading = false;
              if (data["STATUS"] == 0) { this.errorShowService.showError(data['MESSAGE']); }
              else {
                this.tokenService.setLoginData({ email: '', password: '', rememberMe: this.remembermeStatus }, data['DATA'][0])
                if (this.popup) {
                  this.dialogRef.close();
                }
                else {
                  this.router.navigateByUrl(this.roleService.getDefaultRedirection());
                }
                this.navShareService.isNotify$.subscribe(data => {
                  if (data && this.tokenService.getUserId()) {
                    this.deviceAPI();
                  }
                })
                this.loaderclose();
              }
            })
          }
        }
      }
    })
  }
  signup() {
    this.router.navigateByUrl("/signup");
  }
  changeMob() {
    this.changeMobile = false;
    this.phonenumber = "";
    this.enterOtp = false;
  }
}

